const styles = (theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center'
  },
  headerText: {
    fontWeight: 600,
    fontSize: 16,
    color: theme.palette.primary.main
  },
  container: {
    padding: '8px 10px',
    height: '98%',
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  appLoad: {
    width: '46%'
  },
  fullHeight: { height: '100%', display: 'block' },
  viewContainer: {
    height: '98%'
  }
});

export default styles;
